import { IMAGE_KIND } from 'Pages/vehicles/helpers/images.const';
import { logger } from 'Services/logger/logger';
import { formatNumber } from 'Utilities/formatters';
import { isAxiosError } from 'Utilities/isAxiosError';

const PREVIEW_WIDTH = 1200;
const PREVIEW_HEIGHT = 630;

export const getVehiclePageMeta = async (urlPath?: string | string[]) => {
	const [, enquiryId] = typeof urlPath === 'string' ? /^\/vehicles\/\d+\?vehicleId=(\d+)$/.exec(urlPath) || [] : [];

	if (process.env.ENABLE_LINK_PREVIEW !== 'true' || !enquiryId) return {};

	try {
		// eslint-disable-next-line import/no-restricted-paths
		const api = await import('Services/motorway/services/dealershipComposer/getVehicleDetailsWithPhotos');
		const vehicle = await api.getVehicleDetailsWithPhotos(enquiryId);

		const leadPhoto = vehicle?.vehicleImages?.find(({ kind }) => kind === IMAGE_KIND.exteriorFrontDriver);
		const leadPhotoUrl = leadPhoto ? new URL(leadPhoto.url) : undefined;
		const image = leadPhotoUrl
			? `${leadPhotoUrl.origin}${leadPhotoUrl.pathname}?w=${PREVIEW_WIDTH}&h=${PREVIEW_HEIGHT}&lp-blur=20`
			: undefined;

		const description = [
			vehicle?.mileage ? `${formatNumber(vehicle.mileage)} miles` : '',
			vehicle?.spec?.fuel,
			vehicle?.spec?.transmission,
		]
			.filter(Boolean)
			.join(' | ');

		const title = [
			vehicle?.spec?.make,
			vehicle?.spec?.model,
			vehicle?.spec?.manufactureYear ? `(${vehicle.spec.manufactureYear})` : '',
		]
			.filter(Boolean)
			.join(' ');

		return {
			meta: {
				description: `${description ? `${description}. ` : ''}See full spec & photos »`,
				height: PREVIEW_HEIGHT,
				image,
				title: `${title ? `${title} | ` : ''}Motorway`,
				width: PREVIEW_WIDTH,
			},
		};
	} catch (error) {
		const err = {
			context: { enquiryId },
			error: error as Error,
			message: 'Error on generating vehicle page metadata',
			scope: 'getVehiclePageMeta',
		};
		if (isAxiosError(error) && error.status === 404) logger.warn(err);
		else logger.error(err);
	}

	return {};
};
